import { NgModule } from '@angular/core';
import { ProductListAdmin } from './admin/productListAdmin.component';
import { ProductList } from './productList/productList.component';
import { ConvertToSpacesPipe } from '../shared/convert-to-space.pipe';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { RouterModule } from '@angular/router';
import { ProductDetailGuard } from './product-detail/product-detail.guard';
import { SharedModule } from '../shared/shared.module';
import { ProductTypeList } from './productTypes/productTypeList.component';
import { SlideshowModule } from 'ng-simple-slideshow';


@NgModule({
    declarations: [
        ProductListAdmin,
        ConvertToSpacesPipe,
        ProductDetailComponent,
        ProductList,
        ProductTypeList
    ],
  imports: [
      RouterModule.forChild([
          //{ path: '**', redirectTo: 'productTypes', pathMatch: 'full' },
          { path: "", component: ProductTypeList },
          //{ path: 'products', component: ProductList },
          { path: 'adminProducts', component: ProductListAdmin },
          {
              path: 'products/:productId',
              canActivate: [ProductDetailGuard],
              component: ProductDetailComponent
          },
          { path: 'productTypes', component: ProductTypeList },
          {
              path: 'productTypes/:productTypeId',
              component: ProductList
          },
      ]),
      SharedModule,
      SlideshowModule
  ]
})
export class ProductModule { }
